import { IITopMenuDesktopItem, IITopMenuDesktopSection } from '../../../interfaces';

interface ITopMenuDesktopSubMenuProps {
    item: IITopMenuDesktopItem;
    subMenuItem: IITopMenuDesktopSection;
    index: number;
}

const TopMenuDesktopSubMenu = ({ item, subMenuItem, index }: ITopMenuDesktopSubMenuProps) => {

    return (
        <ul className="p-2" key={ `sub-menu-item-${ index }` }>
            { subMenuItem.sectionTitle && <li className="font-medium text-black mb-4">{ subMenuItem.sectionTitle }</li> }
            {
                subMenuItem.sectionItems.map((sectionItem, k) => {
                    const shouldOpenNewTab = sectionItem.link.startsWith('http');
                    const text = sectionItem.text;

                    /* eslint-disable react/jsx-no-target-blank  */
                    return (
                        <li className="mb-2" key={ `${ text }-${ sectionItem.link }-${ k }` }>
                            <a
                                href={ sectionItem.link }
                                target={ shouldOpenNewTab ? '_blank' : '_self' }
                                rel={ shouldOpenNewTab ? 'noreferrer' : '' }
                                className="hover:underline text-gray-500 no-underline"
                                data-gaevent="Top Menu"
                                data-gavalue={ `${ subMenuItem.sectionTitle ?? item.text } > ${ text }` }>{ text }</a>
                        </li>
                    )
                })
            }
        </ul>
    )
};

export default TopMenuDesktopSubMenu;